import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody, CardTitle, Alert} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone,} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {enumPermissionsList} from "../../../store/enums/permissions/actions";
import {connect} from "react-redux";

class EnumPermissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissionsData: [],
      loading: false,
      error: "",
    }
  }

  componentDidMount() {
    const {onEnumPermissionsList} = this.props;
    onEnumPermissionsList({history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        permissionsData: this.props.response.response ? this.props.response.response : [],
        loading: this.props.loading,
        error: this.props.error
      });
    }
  }

  render() {
    document.title = "Enum Permissions | FileJet";

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "name", text: "Name", sort: true,
    }, {
      dataField: "description", text: "Description", sort: true,
    }, {
      dataField: "is_frontend", text: "Is Frontend", sort: true,
    }, {
      dataField: "created", text: "Created", sort: true,
    },];

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.permissionsData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.name.toLowerCase().includes(searchText) || row.description.toLowerCase().includes(searchText) || row.created.includes(searchText))
        return true
      return false
    }

    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={this.props.t("FileJet")}
            breadcrumbItem={this.props.t("Enum Permissions")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={this.state.permissionsData}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={this.state.permissionsData}
                      search={{onColumnMatch}}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col md="12">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {this.state.loading && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {this.state.error.length > 0 && (<div className="mt-3">
                    <Alert color="danger" role="alert">
                      {this.state.error}
                    </Alert>
                  </div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>);
  }
}

EnumPermissions.propTypes = {
  response: PropTypes.any, onEnumPermissionsList: PropTypes.func,
};

const mapStateToProps = ({EnumPermissions}) => ({
  response: EnumPermissions.responseList,
  loading: EnumPermissions.loadingList,
  error: EnumPermissions.errorList,
});

const mapDispatchToProps = dispatch => ({
  onEnumPermissionsList: data => dispatch(enumPermissionsList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EnumPermissions));
